import type {
  AxisIdToDimension,
  XYChartAxisInternal,
} from '../types/xy-chart-internals.js';

type AxisCoordinate = XYChartAxisInternal['coordinate'];

/**
 * Determines which coordinates have grouped series based on the provided axisIdToDimension and axes.
 */
export const getGroupedAxisCoordinates = (
  axisIdToDimension: AxisIdToDimension,
  axes: XYChartAxisInternal[],
): Set<AxisCoordinate | undefined> =>
  new Set(
    [...axisIdToDimension.keys()].map((axisId) => {
      const axis = axes.find((a) => a.id === axisId);
      return axis?.coordinate;
    }),
  );
